import { api } from '..'
import { TSnmpDevice } from 'shared/types'
import { useQuery } from '@tanstack/react-query'

export const getSnmpDevice = (deviceId: string) =>
  api.get<TSnmpDevice>(`/v1/snmp/devices/${deviceId}`).then(({ data }) => data)

export const useGetSnmpDevice = (deviceId: string) => {
  return useQuery({
    queryFn: () => getSnmpDevice(deviceId),
    queryKey: ['snmpDevice', deviceId],
  })
}
